import { Component } from '@angular/core';
import {
    UilabMatButton,
    UilabMatSidenavModule,
} from '@uilab/ng-mat-components';
import { CodeExampleComponent } from 'src/app/shared/components/code-example/code-example.component';
import { CodeExampleHeaderComponent } from 'src/app/shared/components/code-example/code-example-header.component';
import { COMPONENT_EXAMPLES_CONSTANTS } from '../component-examples.constants';

interface SideSheetExample {
    readonly variant: 'basic';
    readonly label: string;
    readonly description: string;
    readonly htmlSnippet: string;
}

@Component({
    selector: 'avd-side-sheet-examples',
    standalone: true,
    templateUrl: './side-sheet-examples.component.html',
    styleUrls: ['./side-sheet-examples.component.scss'],
    imports: [
        CodeExampleHeaderComponent,
        CodeExampleComponent,
        UilabMatButton,
        UilabMatSidenavModule,
    ],
})
export class SideSheetExamplesComponent {
    readonly packageName = COMPONENT_EXAMPLES_CONSTANTS.PACKAGE_NAME;
    readonly getStartedLink = COMPONENT_EXAMPLES_CONSTANTS.GET_STARTED_LINK;
    readonly storybookLink = `${COMPONENT_EXAMPLES_CONSTANTS.STORYBOOK_BASE_URL}/?path=/story/components-sidenav--sidenav-example`;
    readonly repoLink = `${COMPONENT_EXAMPLES_CONSTANTS.AZURE_DEVOPS_BASE_URL}&path=/projects/components/src/lib/sidenav`;

    readonly examples: readonly SideSheetExample[] = [
        {
            variant: 'basic',
            label: 'Basic Side-sheet',
            description:
                'Use a side-sheet to reveal contextual details without navigating away from the current page.',
            htmlSnippet: `<button uilabMatButton="outlined" (click)="toggleBasicExample()">
    Toggle side-sheet
</button>

<uilab-mat-sidenav-container>
    <uilab-mat-sidenav mode="over" position="end" [opened]="basicExampleOpened">
      <h4>Side-sheet title</h4>
      <p>Use this area for contextual information and follow-up actions.</p>
      <button uilabMatButton="text" (click)="closeBasicExample()">
          Close
      </button>
    </uilab-mat-sidenav>

    <uilab-mat-sidenav-content>
        Main content stays visible while the side-sheet is open.
    </uilab-mat-sidenav-content>
</uilab-mat-sidenav-container>`,
        },
    ];

    basicExampleOpened = false;

    toggleBasicExample(): void {
        this.basicExampleOpened = !this.basicExampleOpened;
    }

    closeBasicExample(): void {
        this.basicExampleOpened = false;
    }
}
